/* Budli search panel: shows popular searches, categories, brands and a promo when the search field is focused and empty. */
(function () {
  if (window.__budliSearchPanel) return;
  window.__budliSearchPanel = true;

  var F = 'https://cdn.shopify.com/s/files/1/0961/0490/files/';
  var assetBase = (document.currentScript && document.currentScript.src) ? document.currentScript.src.replace(/budli-search\.js.*$/, '') : '';
  var POPULAR = ['iPhone 13', 'iPhone 12', 'iPhone 14', 'Samsung Galaxy S23', 'MacBook Pro M1', 'iPad 9th Gen', 'Apple Watch', 'OnePlus 10'];
  var CATS = [
    ['Mobiles', 'wat-mobiles.webp', '/collections/mobile-phones'],
    ['Laptops', 'wat-laptops.webp', '/collections/laptops'],
    ['Tablets', 'wat-tablets.webp', '/collections/tablets'],
    ['Watches', 'wat-watch.webp', '/collections/smartwatches'],
    ['Speakers', 'wat-speaker.webp', '/collections/speaker'],
    ['Audio', 'wat-audio.webp', '/collections/headphones'],
    ['Desktops', 'wat-desktop.webp', '/collections/buy-refurbished-desktops'],
    ['Accessories', 'wat-accessories.webp', '/collections/accessories']
  ];
  var BRANDS = [
    ['Apple', 'brands-apple.webp', '/collections/apple'],
    ['Samsung', 'brands-samsung.webp', '/collections/samsung'],
    ['OnePlus', 'brands-oneplus.webp', '/collections/oneplus'],
    ['Google', 'brands-google.webp', '/collections/renewed-google-pixel-mobiles'],
    ['Xiaomi', 'brands-xiaomi.webp', '/collections/refurbished-xiaomi-mobiles'],
    ['Dell', 'brands-dell.webp', '/collections/refurbished-dell-laptops'],
    ['HP', 'brands-hp.webp', '/collections/hp-refurbished-laptop'],
    ['Lenovo', 'brands-lenovo.webp', '/collections/lenovo-refurbished-laptop']
  ];
  var KEY = 'budliRecentSearches';

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function recent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]').slice(0, 5); } catch (e) { return []; } }
  function remember(q) {
    q = (q || '').trim(); if (!q) return;
    try { var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); r.unshift(q); localStorage.setItem(KEY, JSON.stringify(r.slice(0, 5))); } catch (e) {}
  }
  function qlink(q) { return '/search?q=' + encodeURIComponent(q); }
  var RV = 'budliRecentViewed';
  function viewed() { try { var r = JSON.parse(localStorage.getItem(RV) || '[]'); return Array.isArray(r) ? r.slice(0, 6) : []; } catch (e) { return []; } }
  function recordView() {
    var m = location.pathname.match(/^\/products\/([^/?#]+)/); if (!m) return;
    function meta(p) { var e = document.querySelector('meta[property="' + p + '"]'); return e ? e.getAttribute('content') : ''; }
    var item = { h: decodeURIComponent(m[1]), t: meta('og:title').replace(/\s*\([^)]*\)\s*$/, ''), p: meta('og:price:amount'), i: meta('og:image') };
    if (!item.t) return;
    try { var r = viewed().filter(function (x) { return x.h !== item.h; }); r.unshift(item); localStorage.setItem(RV, JSON.stringify(r.slice(0, 6))); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', recordView); else recordView();
  function thumb(u) { return String(u || '').replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2'); }

  function build() {
    var rec = recent();
    var h = '<button type="button" class="bsp__close" data-close aria-label="Close search"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>';
    h += '<div class="bsp__main">';
    if (rec.length) {
      h += '<div class="bsp__sec"><p class="bsp__t">Recent searches <button type="button" class="bsp__clear" data-clear>Clear</button></p><div class="bsp__chips">' +
        rec.map(function (q) { return '<a class="bsp__chip bsp__chip--recent" href="' + qlink(q) + '" data-q="' + esc(q) + '">' + esc(q) + '</a>'; }).join('') + '</div></div>';
    }
    var vw = viewed();
    if (vw.length) {
      h += '<div class="bsp__sec"><p class="bsp__t">Recently viewed</p><div class="bsp__rv">' +
        vw.map(function (v) { return '<a class="bsp__rvi" href="/products/' + esc(v.h) + '"><img src="' + esc(thumb(v.i)) + '" alt="" width="64" height="64" loading="lazy"><span class="bsp__rvt">' + esc(v.t) + '</span>' + (v.p ? '<span class="bsp__rvp">\u20B9' + esc(v.p) + '</span>' : '') + '</a>'; }).join('') + '</div></div>';
    }
    h += '<div class="bsp__sec"><p class="bsp__t">Popular searches</p><div class="bsp__chips bsp__chips--pop">' +
      POPULAR.map(function (q) { return '<a class="bsp__chip" href="' + qlink(q) + '" data-q="' + esc(q) + '">' + esc(q) + '</a>'; }).join('') + '</div></div>';
    h += '<div class="bsp__sec"><p class="bsp__t">Shop by category</p><div class="bsp__cats">' +
      CATS.map(function (c) { var src = (c[1] === 'wat-accessories.webp' && assetBase) ? (assetBase + c[1]) : (F + c[1]); return '<a class="bsp__cat" href="' + c[2] + '"><img src="' + src + '" alt="" width="56" height="56"><span>' + c[0] + '</span></a>'; }).join('') + '</div></div>';
    h += '<div class="bsp__sec"><p class="bsp__t">Top brands</p><div class="bsp__brands">' +
      BRANDS.map(function (b) { return '<a class="bsp__brand" href="' + b[2] + '" title="' + b[0] + '"><img src="' + F + b[1] + '" alt="' + b[0] + '" height="28"></a>'; }).join('') + '</div></div>';
    h += '</div><a class="bsp__promo" href="/collections/mobile-phones"><span class="bsp__pk">Budli Certified</span><strong>Save up to 70% vs new retail</strong><span class="bsp__pl">25-point checked &middot; up to 12-month warranty &middot; 7-day returns &middot; No-cost EMI</span><span class="bsp__pc">Shop best deals &rarr;</span></a>';
    return h;
  }

  function preload() {
    CATS.concat(BRANDS).forEach(function (x) { var i = new Image(); i.src = (x[1] === 'wat-accessories.webp' && assetBase) ? (assetBase + x[1]) : (F + x[1]); });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(preload, { timeout: 4000 }); else setTimeout(preload, 2500);

  var panel = document.createElement('aside');
  panel.className = 'bsp'; panel.id = 'budli-search-panel'; panel.setAttribute('role', 'region'); panel.setAttribute('aria-label', 'Search suggestions'); panel.hidden = true;
  document.body.appendChild(panel);
  var current = null;

  function place(input) {
    var r = input.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    if (vw < 750) { panel.style.left = '8px'; panel.style.right = '8px'; panel.style.width = 'auto'; panel.style.top = (r.bottom + 6) + 'px'; return; }
    var w = Math.min(760, vw - 32);
    var left = Math.max(16, Math.min(r.right - w, vw - w - 16));
    panel.style.width = w + 'px'; panel.style.left = left + 'px'; panel.style.right = 'auto'; panel.style.top = (r.bottom + 8) + 'px';
  }
  function show(input) {
    if ((input.value || '').trim()) { hide(); return; }
    current = input; panel.innerHTML = build(); place(input); panel.hidden = false; document.documentElement.classList.add('bsp-open');
  }
  function hide() { panel.hidden = true; document.documentElement.classList.remove('bsp-open'); }

  function isSearch(el) { return el && el.matches && el.matches('input[type="search"], input.search__input, input[name="q"]') && !el.closest('.bsp'); }

  document.addEventListener('focusin', function (e) { if (isSearch(e.target)) show(e.target); });
  document.addEventListener('click', function (e) {
    if (isSearch(e.target)) { if (panel.hidden) show(e.target); return; }
    if (!panel.contains(e.target)) hide();
  });
  document.addEventListener('input', function (e) { if (isSearch(e.target)) { if ((e.target.value || '').trim()) hide(); else show(e.target); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  window.addEventListener('resize', function () { if (!panel.hidden && current) place(current); });
  window.addEventListener('scroll', function () { if (!panel.hidden && current) place(current); }, { passive: true });
  panel.addEventListener('mousedown', function (e) {
    if (e.target.closest('[data-close]')) return;
    e.preventDefault();
  });
  panel.addEventListener('pointerdown', function (e) {
    var close = e.target.closest('[data-close]');
    if (close) {
      e.preventDefault();
      e.stopPropagation();
      hide();
      if (current) current.blur();
    }
  });
  panel.addEventListener('click', function (e) {
    var close = e.target.closest('[data-close]');
    if (close) {
      e.preventDefault();
      e.stopPropagation();
      hide();
      if (current) current.blur();
      return;
    }
    var clr = e.target.closest('[data-clear]');
    if (clr) { try { localStorage.removeItem(KEY); } catch (x) {} panel.innerHTML = build(); return; }
    var a = e.target.closest('a[data-q]'); if (a) remember(a.getAttribute('data-q'));
  });
  document.addEventListener('submit', function (e) { var i = e.target && e.target.querySelector && e.target.querySelector('input[name="q"]'); if (i) remember(i.value); }, true);
  /* signed-in marker: budli.in sets the display-only cookie budli_ident=1 for .budli.in after login */
  function markSignedIn() {
    if (!/(?:^|; )budli_ident=1(?:;|$)/.test(document.cookie)) return;
    var a = document.querySelector('.header__icon--account');
    if (!a) return;
    a.classList.add('is-signed-in');
    a.setAttribute('aria-label', 'My Account (signed in)');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markSignedIn); else markSignedIn();
})();
